module.exports = __webpack_public_path__ + "static/media/passenger-rear-preview.6951e90a.svg";